export interface CompaniesFilter {
    textSearch?: string;
    mandateManagerIds?: string[];
    clerkIds?: string[];
    /** REV-22155 */
    tagIds?: string[];
}
